import * as React from 'react';
import { IDsiResult } from '../../../data/providers/reports/dsiReportProvider';
import { Entity } from '../../../data/types';
import { formatDayFromUtc } from '../../../utils/date';
import { Row } from '../../layout/Row';
import { Metric } from '../../shared/Metric';
import { EPdfMode } from '../../shared/pdf/Pdf';
import { DataWarning } from '../utils/DataWarning';
import { DataCell, DataColumn } from '../utils/Table';

interface IProps {
  result: IDsiResult;
  pdfMode: EPdfMode;
  entity: Entity;
  shape: number[];
}

export const DsiResult = (props: IProps): React.ReactElement => {
  return (
    <Row
      className='avoid-break'
      style={{
        height: '100%',
      }}
    >
      <DataColumn style={{ flex: props.shape[0] }}>
        <DataCell>{props.result.displayDate}</DataCell>
      </DataColumn>
      <DataColumn style={{ flex: props.shape[1] }}>
        <DataCell style={{ position: 'relative' }}>
          {props.result.cmjStale && props.result.cmjPeak ? (
            <DataWarning
              message={`The CMJs were performed on ${formatDayFromUtc(
                props.result.cmjDate
              )}`}
            />
          ) : null}
          <Metric
            isSecondary
            style={{ alignItems: 'center' }}
            value={props.result.cmjPeak}
            units='N'
          />
        </DataCell>
      </DataColumn>
      <DataColumn style={{ flex: props.shape[2] }}>
        <DataCell style={{ position: 'relative' }}>
          {props.result.isoStale && props.result.isoPeak ? (
            <DataWarning
              message={`The Isometric Tests were performed on ${formatDayFromUtc(
                props.result.isoDate
              )}`}
            />
          ) : null}
          <Metric
            isSecondary
            style={{ alignItems: 'center' }}
            value={props.result.isoPeak}
            units='N'
          />
        </DataCell>
      </DataColumn>
      <DataColumn style={{ flex: props.shape[3] }}>
        <DataCell style={{ position: 'relative' }}>
          {props.result.dsiStale && props.result.dsi ? (
            <DataWarning message='The Isometric and the CMJ tests were not performed on the same day.' />
          ) : null}
          <Metric
            style={{ alignItems: 'center' }}
            value={props.result.dsi}
            units=''
          />
        </DataCell>
      </DataColumn>
      <DataColumn style={{ flex: props.shape[4] }}>
        <DataCell>
          <Metric
            isSecondary
            style={{ alignItems: 'center' }}
            value={props.result.dsiPercentageChange}
            units='%'
          />
        </DataCell>
      </DataColumn>
      <DataColumn style={{ flex: props.shape[5] }}>
        <DataCell>
          <Metric
            isSecondary
            style={{ alignItems: 'center' }}
            value={props.result.dsiTotalChange}
            units=''
          />
        </DataCell>
      </DataColumn>
    </Row>
  );
};
